export default {
  loading_menu: 'Menu laden...',
};
